export default __webpack_public_path__ + "static/media/2829 knife block A side.2ba368da.png";